import { render, staticRenderFns } from "./TenderTypeForm.vue?vue&type=template&id=9f4cae9e&"
import script from "./TenderTypeForm.vue?vue&type=script&lang=js&"
export * from "./TenderTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports